import React, { useEffect } from 'react';

import { connect } from 'react-redux';

import { PageHeader } from '../../components';
import DataTable from '../../components/DataTable/DataTable';

import useComponentState from '../../utils/useComponentState';
import { getRolesList } from '../../api/RolePermission';

import styles from './ViewRoles.module.scss';

const TABLE_HEADING = {
  column: ['Name', 'Description', 'Created At', 'Created By'],
};

const INITIAL_STATE = {
  roles: [],
  rolesError: '',
  loadingRoles: false,
};

const ViewRoles = ({ auth }) => {
  const [state, setState] = useComponentState(INITIAL_STATE);
  const token = auth.auth.token;

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    setState({ loadingRoles: true, rolesError: '' });
    try {
      const res = await getRolesList(token);
      setState({ roles: Array.isArray(res) ? res : [], loadingRoles: false });
    } catch (err) {
      setState({
        loadingRoles: false,
        rolesError: 'Failed to load roles. Please try again.',
      });
    }
  };

  return (
    <div className={styles.root_div}>
      <PageHeader text='Roles' />

      <div className={styles.tableContainer}>
        <div className={styles.sectionTitle}>Existing Roles</div>
        <DataTable
          tableData={state.roles}
          tableheading={TABLE_HEADING}
          tag='roles'
          fetchError={state.rolesError}
          search_filter_loading={state.loadingRoles}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ auth: state.auth });

export default connect(mapStateToProps)(ViewRoles);
